import { render, staticRenderFns } from "./GraficoPercentual.vue?vue&type=template&id=1a52e516&scoped=true"
import script from "./GraficoPercentual.vue?vue&type=script&lang=js"
export * from "./GraficoPercentual.vue?vue&type=script&lang=js"
import style0 from "../../styles.scss?vue&type=style&index=0&id=1a52e516&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a52e516",
  null
  
)

export default component.exports